import { Injectable } from '@angular/core';

import { ApiBase, ApiServiceFactory, ClientConfigProductName, ProductService } from '@frontend/vanilla/core';

@Injectable({
    providedIn: 'root',
    useFactory: apiServiceFactory,
    deps: [ApiServiceFactory, ProductService],
})
export class PaymentsApiService extends ApiBase {}

export function apiServiceFactory(apiServiceFactory: ApiServiceFactory) {
    return apiServiceFactory.createForProduct(PaymentsApiService, {
        product: ClientConfigProductName.PAYMENTS,
        area: 'payments',
        forwardProductApiRequestHeader: true,
    });
}
